// React Utilities
import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
// React Bootstrap
import { Card } from "react-bootstrap";
import { isMobile } from "react-device-detect";
import jwt_decode from "jwt-decode";
// Custom API's
import JajotApi from "../../api/JajotApi";
// Custom Components
import UpdateImage from "../modal/UpdateImage";

const Sidebar = () => {
  const [userInfo, setUserInfo] = useState();
  const [userPofile, setUserProfile] = useState();
  const [enableModal, setEnableModal] = useState(false);
  const [changeImage, setChangeImage] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      let user = await JajotApi.getContactRecordByEmail();
      let userProfile = await JajotApi.getEmployeeImage();
      if (userProfile?.success) {
        setUserProfile(userProfile?.record);
      } else {
        setUserProfile(user?.profile);
      }
      if (user?.success) {
        setUserInfo(user?.records);
      }
    })();
    setUserInfo(jwt_decode(localStorage.getItem("token")));
  }, [changeImage]);

  // Remove unnecessary logging effect to avoid lint warnings

  const navigatePage = (destination, defaultHide) => {
    if (isMobile) hideSideBar();
    setTimeout(() => {
      navigate(destination);
    }, 100);
  };
  const hideSideBar = () => {
    const sidebar = document.querySelector("#sidebar");
    if (!sidebar) return;
    // Always hide on explicit close
    sidebar.classList.add("hide");
    sidebar.classList.remove("show");
    document.body.classList.remove("sidebar-open");
  };

  return (
    userInfo !== undefined && (
      <>
        <nav id="sidebar" className={isMobile ? "hide mobile-sidebar" : "show"}>
          <div className="d-flex justify-content-center align-items-center px-2 py-2">
            {userPofile?.url !== undefined ? (
              <Card style={{ width: "100%" }} className="border-0">
                <Card.Title className="text-end m-0 p-1 cursor-pointer">
                  <i
                    className="fa-solid fa-pencil rounded-1 border p-1 fs-6"
                    onClick={() => setEnableModal(!enableModal)}
                  ></i>
                </Card.Title>
                <Card.Body className="p-2">
                  <div className="image-container d-flex justify-content-center mb-1">
                    <Card.Img
                      src={userPofile?.url}
                      varient="top"
                      className="img-container rounded-circle img-fluid p-1"
                      style={{
                        border: "2px solid var(--primary-color)",
                        height: "120px",
                        width: "120px",
                      }}
                    />
                  </div>
                  <p className="text-center m-0">
                    <span className="heading" style={{ fontSize: "13px" }}>
                      {userInfo?.Name ? userInfo?.Name : "Employee Name"}
                    </span>{" "}
                    <br />
                    <span style={{ fontSize: "12px" }}>
                      {userInfo?.Designation__c
                        ? userInfo?.Designation__c
                        : "Employee Designation"}
                    </span>
                  </p>
                </Card.Body>
              </Card>
            ) : (
              <Card style={{ width: "100%" }} className="border-0">
                <Card.Title className="text-end m-0 p-1 cursor-pointer">
                  <i
                    className="fa-solid fa-pencil rounded-1 border p-1 fs-6"
                    onClick={() => setEnableModal(!enableModal)}
                  ></i>
                </Card.Title>
                <Card.Body className="p-2">
                  <div className="image-container d-flex justify-content-center mb-1">
                    <Card.Img
                      src="/default_emp_profile.png"
                      varient="top"
                      className="img-container rounded-circle img-fluid"
                      style={{
                        border: "2px solid var(--primary-color)",
                        height: "120px",
                        width: "120px",
                      }}
                    />
                  </div>
                  <p className="text-center m-0">
                    <span className="heading" style={{ fontSize: "13px" }}>
                      {userInfo?.Name ? userInfo?.Name : "Employee Name"}
                    </span>{" "}
                    <br />
                    <span style={{ fontSize: "12px" }}>
                      {userInfo?.Designation__c
                        ? userInfo?.Designation__c
                        : "Employee Designation"}
                    </span>
                  </p>
                </Card.Body>
              </Card>
            )}
          </div>
          <div>
            <ul
              className="list-unstyled components menu-list"
            >
              <li className={`${location.pathname === "/" ? "active" : ""}`}>
                <span
                  className="custom-link-sidebar heading"
                  onClick={(e) => navigatePage("/", false)}
                >
                  <i className="fa-solid fa-house mx-2"></i> Home
                </span>
              </li>

              <li
                className={`${location.pathname === "/attendance" ? "active" : ""
                  }`}
              >
                <span
                  className="custom-link-sidebar heading"
                  onClick={(e) => navigatePage("/attendance", false)}
                >
                  <i className="fa-solid fa-book mx-2"></i> Attendance
                </span>
              </li>

              <li
                className={`${location.pathname.includes("payroll") ? "active" : ""
                  }`}
              >
                <span
                  className="custom-link-sidebar heading"
                  onClick={(e) => navigatePage("payroll", false)}
                >
                  <i className="fa-solid fa-receipt mx-2"></i> Pay Slips
                </span>
              </li>

              <li
                className={`${location.pathname.includes("target") ? "active" : ""
                  }`}
              >
                <span
                  className="custom-link-sidebar heading"
                  onClick={(e) => navigatePage("target", false)}
                >
                  {" "}
                  <i className="fa-solid fa-bullseye mx-2"></i> Target
                </span>
              </li>

              <li
                className={`${location.pathname.includes("leave") ? "active" : ""
                  }`}
              >
                <span
                  className="custom-link-sidebar heading"
                  onClick={(e) => navigatePage("leave", false)}
                >
                  {" "}
                  <i className="fa-solid fa-person-walking-luggage mx-2"></i>{" "}
                  Leaves
                </span>
              </li>
              <li
                className={`${location.pathname.includes("ledger") ? "active" : ""
                  }`}
              >
                <span
                  className="custom-link-sidebar heading"
                  onClick={(e) => navigatePage("ledger", false)}
                >
                  {" "}
                  <i className="fa fa-book-open mx-2"></i> Ledger
                </span>
              </li>
              <li
                className={`${location.pathname.includes("stock-items") ? "active" : ""
                  }`}
              >
                <span
                  className="custom-link-sidebar heading"
                  onClick={(e) => navigatePage("stock-items", false)}
                >
                  {" "}
                  <i className="fa fa-boxes-stacked mx-2"></i> Stock Items
                </span>
              </li>
              <li
                className={`${location.pathname.includes("voucher") ? "active" : ""
                  }`}
              >
                <span
                  className="custom-link-sidebar heading"
                  onClick={(e) => navigatePage("voucher", false)}
                >
                  {" "}
                  <i className="fa fa-receipt mx-2"></i> Voucher
                </span>
              </li>
              <li
                className={`${location.pathname.includes("order") ? "active" : ""
                  }`}
              >
                <span
                  className="custom-link-sidebar heading"
                  onClick={(e) => navigatePage("order", false)}
                >
                  {" "}
                  <i className="fa fa-shopping-cart mx-2"></i> Orders
                </span>
              </li>

              {/**@AddedBy : Mohmmad Sarfaraz | 21-Nov-2025 */}
              <li className={`${location.pathname.includes("task") ? "active" : ""}`}>
                <span
                  className="custom-link-sidebar heading"
                  onClick={(e) => navigatePage("task", false)}
                >{" "}<i className="fa-solid fa-tasks mx-2"></i> Task Manager
                </span>
              </li>
              <li className={`${location.pathname.includes("event") ? "active" : ""}`}>
                <span
                  className="custom-link-sidebar heading"
                  onClick={(e) => navigatePage("event", false)}
                >{" "}<i className="fa-solid fa-calendar-days mx-2"></i> Event
                </span>
              </li>
              <li
                className={`${location.pathname.includes("reports") ? "active" : ""
                  }`}
              >
                <span
                  className="custom-link-sidebar heading"
                  onClick={(e) => navigatePage("reports", false)}
                >
                  {" "}
                  <i className="fa fa-chart-line mx-2"></i> Reports
                </span>
              </li>



              <li
                className={`${location.pathname.includes("changepassword") ? "active" : ""
                  }`}
              >
                <span
                  className="custom-link-sidebar heading"
                  onClick={(e) => navigatePage("changepassword", false)}
                >
                  {" "}
                  <i className="fa-solid fa-key mx-2"></i> Change Password
                </span>
              </li>

              <div
                className="sidebar-header text-dark"
                style={{
                  padding: "1rem 2rem 2rem 1rem",
                  borderTop: "1px solid #15a362",
                  textAlign: "center",
                }}
              >
                <img
                  src="/ibirds_logo.png"
                  style={{ width: "50%" }}
                  alt="indicrm.logo"
                />
                <p style={{ paddingTop: ".5rem" }}>
                  Powered by{" "}
                  <a
                    href="https://indicrm.io"
                    target="__blank"
                    style={{ color: "#15a362" }}
                  >
                    indiCRM.io
                  </a>
                </p>
              </div>
            </ul>
          </div>
        </nav >
        {isMobile && <div className="overlay" onClick={hideSideBar}></div>
        }

        <UpdateImage
          show={enableModal}
          changeImage={changeImage}
          setChangeImage={setChangeImage}
          previousImage={userPofile?.url}
          onHide={setEnableModal}
        />
      </>
    )
  );
};

export default Sidebar;
